import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoComprobantePage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoComprobantePage",
            ss: ss,
            auth: {},
            ajax: {
                "url": ss.indexTipoComprobante(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoComprobante', name: 'TipoComprobante', title: 'Tipo Comprobante' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            TipoComprobantes: [],
            TipoComprobante: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoComprobante() {
            this.TipoComprobante = {};
            this.$refs['frm-TipoComprobante'].show();
        },
        showTipoComprobante(id) {
            this.isLoading=true;
            this.ss.showTipoComprobante(id).then(
                (result) => {
                    let response = result.data;
                    this.TipoComprobante = response.data;
                    this.$refs['view-TipoComprobante'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoComprobante() {
            this.$refs['frm-TipoComprobante'].show();
            this.$refs['view-TipoComprobante'].hide();
        },
        cancelTipoComprobante() {
            if (this.TipoComprobante.id) {
                this.$refs['view-TipoComprobante'].show();
            }
            this.$refs['frm-TipoComprobante'].hide();
        },
        saveTipoComprobante() {
            this.ss.storeTipoComprobante(this.TipoComprobante).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-TipoComprobante'].hide();
                    this.$refs['datatable-TipoComprobante'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoComprobante() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTipoComprobante(this.TipoComprobante)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-TipoComprobante'].hide();
                                this.$refs['datatable-TipoComprobante'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoComprobante').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoComprobante(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
